/* MagicBusAddon.js */

"use strict";
const EventEmitter = require("events").EventEmitter;

class MagicBusAddon extends EventEmitter {
    constructor() {
        super();
    }
    shutdown() {}
}
module.exports = MagicBusAddon;
